module.exports = __webpack_public_path__ + "static/media/architecture-bridge-canada-414462.25dcd102.jpg";